import React, { useMemo,  useState, useEffect } from "react"
import { Container, CardBody, Card } from "reactstrap" 
import Breadcrumb from "components/Common/Breadcrumb"
import { useNavigate } from "react-router-dom"

import moment from "moment" 
import { usePermissionData } from "AppContext"
import PermittedComponent from "components/Common/PermittedComponent"
import { axiosbaseurl } from "configure"
import Loader from "components/Common/Loader"
import CommonTable from "components/Common/CommonTable"

const GocardlessPayments = () => {
  const [table_data, settable_data] = useState([])
  const [account, setAccount] = useState("first")

  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const getPayments = async () => {
      try {
        setLoading(true)
        const response = await axiosbaseurl.get(
          `/goCardless/payments/${account}`
        )
        if (response.data.success) {
          settable_data(response.data.data)
        }
      } catch (error) {
        console.log(error)
      } finally {
        setLoading(false)
      }
    }
    getPayments()
  }, [account])

  document.title = "Gocardless Payments | Peacock Accountants Limited"

  return (
    <>
      {loading && <Loader />}
      <div className="page-content mb-5">
        <Container fluid>
          <Breadcrumb
            title={"Dashboard"}
            breadcrumbItem={"Gocardless Payments"}
          />

          <Card className="px-0 mx-0">
            <CardBody>
              <TableComponent
                table_data={table_data}
                settable_data={settable_data}
                loading={loading}
                account={account}
                setAccount={setAccount}
              />
            </CardBody>
          </Card>
        </Container>
      </div>
    </>
  )
}

const TableComponent = ({
  table_data,
  settable_data,
  loading,
  account,
  setAccount,
}) => {
  const { checkAccess } = usePermissionData()
  const module_id = 26

  const navigate = useNavigate()

  // columns
  const columns = useMemo(
    () => [
      {
        Header: "Payment ID",
        accessor: "paymentId",
        disableFilters: true,
        filterable: true,
      },
      {
        Header: "Mandate ID",
        accessor: "mandateId",
        disableFilters: true,
        filterable: true,
      },
      {
        Header: "Payment Date",
        accessor: "createdAt",
        disableFilters: true,
        filterable: true,
        // className: " text-center",
        Cell: cellProps => {
          return (
            <div>
              {moment(cellProps.row.original.createdAt).format(
                "DD MMM YYYY | hh:mm A"
              )}
            </div>
          )
        },
      },
      {
        Header: "Amount. (£)",
        accessor: "amount",
        disableFilters: true,
        className: " text-center",
        filterable: true,
      },
      {
        Header: "Payment Status",
        accessor: "status",
        disableFilters: true,
        filterable: true,
        className: " text-center",
        Cell: cellProps => {
          const statusColorMap = {
            pending_customer_approval: "bg-warning text-dark",
            pending_submission: "bg-primary text-white",
            submitted: "bg-info text-white",
            confirmed: "bg-success text-white",
            paid_out: "bg-secondary text-white",
            cancelled: "bg-danger text-white",
            customer_approval_denied: "bg-light text-danger",
            failed: "bg-dark text-white",
            charged_back: "bg-warning text-dark",
          }
          const formatStatusText = status => {
            return status
              .split("_")
              .map(
                word =>
                  word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
              )
              .join(" ")
          }
          const status = cellProps.row.original.status
          const formattedStatus = formatStatusText(status)
          const statusClass = statusColorMap[status] || "bg-light text-dark"

          return (
            <div className={`px-2 rounded d-inline fs-6 ${statusClass}`}>
              {formattedStatus}
            </div>
          )
        },
      },
      // {
      //     Header: "Action",
      //     disableFilters: true,
      //     accessor: "view",
      //     className: "text-center",
      //     Cell: cellProps => {
      //         return (
      //             <div>
      //                 <button
      //                     // onClick={() => setViewShow(true)}
      //                     className="btn btn-success bg-green  btn-sm me-2"
      //                 >
      //                     <i className="fas fa-eye me-1"></i> View Reference
      //                 </button>
      //             </div>
      //         )
      //     },
      // },
    ],
    []
  )

  // table data
  const data = useMemo(() => table_data, [table_data])

  return (
    <>
      <PermittedComponent isAccess={checkAccess(module_id, "view")}>

        <CommonTable
          columns={columns}
          data={data}
          heading={"Gocardless Payments"}
        >
          <div>
            <button
              disabled={loading}
              onClick={() => {
                settable_data([])
                setAccount("first")
              }}
              className={`btn btn-${account === "first" ? "primary" : "light" } fw-bold ms-3`}
            >
              Account 1
            </button>

            <button
              disabled={loading}
              onClick={() => {
                settable_data([])
                setAccount("second")
              }}
              className={`btn btn-${account === "second" ? "primary" : "light" } fw-bold ms-3`}
            >
              Account 2
            </button>

            <button
              onClick={() => navigate(-1)}
              className="btn btn-secondary bg-dark ms-3"
            >
              <i className="fas fa-arrow-left me-3"></i>
              Back
            </button>
          </div>
        </CommonTable>
 
      </PermittedComponent>
    </>
  )
}

export default GocardlessPayments
